import { supabase } from '../supabaseClient';

export const contactService = {
  async getContactData(editionYear) {
    try {
      // Get edition ID
      const { data: edition } = await supabase
        .from('editions')
        .select('id')
        .eq('year', editionYear)
        .single();

      if (!edition) {
        throw new Error(`Edition ${editionYear} not found`);
      }

      // Get contact data
      const { data: contactData, error: contactDataError } = await supabase
        .from('contact_data')
        .select('*')
        .eq('edition_id', edition.id)
        .single();

      if (contactDataError && contactDataError.code !== 'PGRST116') {
      }

      return {
        heroSection: {
          title: contactData?.hero_title || 'Contactez-nous',
          subtitle: contactData?.hero_subtitle || 'N\'hésitez pas à nous poser vos questions'
        },
        formSection: {
          title: contactData?.form_title || 'Envoyez-nous un message',
          subtitle: contactData?.form_subtitle || 'Nous vous répondrons dans les plus brefs délais',
          submitButtonText: contactData?.form_submit_button_text || 'Envoyer le message'
        },
        contactInfo: {
          title: contactData?.contact_info_title || 'Informations de contact',
          venue: {
            title: contactData?.venue_title || 'Lieu',
            address: contactData?.venue_address || '',
            subAddress: contactData?.venue_sub_address || ''
          },
          email: {
            title: contactData?.email_title || 'Email',
            primary: contactData?.email_primary || '',
            secondary: contactData?.email_secondary || ''
          },
          phone: {
            title: contactData?.phone_title || 'Téléphone',
            primary: contactData?.phone_primary || '',
            secondary: contactData?.phone_secondary || ''
          },
          social: {
            title: contactData?.social_title || 'Réseaux sociaux',
            website: contactData?.social_website || '',
            handle: contactData?.social_handle || ''
          }
        },
        mapSection: {
          title: contactData?.map_title || 'Localisation',
          description: contactData?.map_description || 'Retrouvez-nous sur la carte',
          coordinates: {
            lat: parseFloat(contactData?.map_lat) || 33.5731,
            lng: parseFloat(contactData?.map_lng) || -7.5898
          },
          popupText: contactData?.map_popup_text || 'Université Hassan II'
        }
      };
    } catch (error) {
      throw error;
    }
  },

  async updateContactData(contactData, editionYear) {
    try {
      // Get edition ID
      const { data: edition } = await supabase
        .from('editions')
        .select('id')
        .eq('year', editionYear)
        .single();

      if (!edition) {
        throw new Error(`Edition ${editionYear} not found`);
      }

      const updateData = {
        edition_id: edition.id,
        hero_title: contactData.heroSection?.title || 'Contactez-nous',
        hero_subtitle: contactData.heroSection?.subtitle || 'N\'hésitez pas à nous poser vos questions',
        form_title: contactData.formSection?.title || 'Envoyez-nous un message',
        form_subtitle: contactData.formSection?.subtitle || 'Nous vous répondrons dans les plus brefs délais',
        form_submit_button_text: contactData.formSection?.submitButtonText || 'Envoyer le message',
        contact_info_title: contactData.contactInfo?.title || 'Informations de contact',
        venue_title: contactData.contactInfo?.venue?.title || 'Lieu',
        venue_address: contactData.contactInfo?.venue?.address || '',
        venue_sub_address: contactData.contactInfo?.venue?.subAddress || '',
        email_title: contactData.contactInfo?.email?.title || 'Email',
        email_primary: contactData.contactInfo?.email?.primary || '',
        email_secondary: contactData.contactInfo?.email?.secondary || '',
        phone_title: contactData.contactInfo?.phone?.title || 'Téléphone',
        phone_primary: contactData.contactInfo?.phone?.primary || '',
        phone_secondary: contactData.contactInfo?.phone?.secondary || '',
        social_title: contactData.contactInfo?.social?.title || 'Réseaux sociaux',
        social_website: contactData.contactInfo?.social?.website || '',
        social_handle: contactData.contactInfo?.social?.handle || '',
        map_title: contactData.mapSection?.title || 'Localisation',
        map_description: contactData.mapSection?.description || 'Retrouvez-nous sur la carte',
        map_lat: contactData.mapSection?.coordinates?.lat || 33.5731,
        map_lng: contactData.mapSection?.coordinates?.lng || -7.5898,
        map_popup_text: contactData.mapSection?.popupText || 'Université Hassan II',
        updated_at: new Date().toISOString()
      };

      // Try to update existing record first
      const { data: existingData } = await supabase
        .from('contact_data')
        .select('id')
        .eq('edition_id', edition.id)
        .single();

      if (existingData) {
        // Update existing record
        const { data, error } = await supabase
          .from('contact_data')
          .update(updateData)
          .eq('id', existingData.id)
          .select()
          .single();

        if (error) throw error;
        return data;
      } else {
        // Insert new record
        const { data, error } = await supabase
          .from('contact_data')
          .insert([updateData])
          .select()
          .single();

        if (error) throw error;
        return data;
      }
    } catch (error) {
      throw error;
    }
  }
};
